module.exports = __webpack_public_path__ + "img/categorie-commentcamarche-famille-boutrais-big.773b238d.jpg";